export default "__VITE_ASSET__IKH1VE8$__"